import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasNon1PMarketShareSplineChart = () => {
  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSalesNon1PMarketShareSplineChart"
      title="Market Share of Retail Sales"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="retailSales"
      showMarketShare={true}
      splineChartProps={{ chartContextId: CHART_NAMES.MARKET_SHARE_RETAIL_SALES_SPLINE }}
    />
  );
};

export default AtlasNon1PMarketShareSplineChart;
